<template>

    <v-layout row wrap class="mt-5">
      <!-- Paso 1 -->
      <v-flex xs10 sm10 md10 lg10 xl10 offset-xs1 >
        <h4 class="primary--text">{{ prueba.section.section_title }}</h4>
        <v-divider></v-divider>
        <h6 class="headline mt-3 gray--text"><strong>Descripción: </strong>{{ prueba.test_description }}</h6>
        <p  class="headline gray--text">
         Cantidad de Preguntas {{ cantidadPreguntas }}  <v-icon  >description</v-icon></p>
        <p class="body-1 gray--text">
          <p  class="headline gray--text">
         Tipo:  {{ prueba.type_test.type_test_nombre }} </p>
        <p class="body-1 gray--text">
        <v-layout column align-center justify-center v-if="performed && prueba.typeTest_id === 1">
          <p>Intentos 1/1</p>
           <v-btn  class="primary white--text mt-5"   @click="verCurso()" >Volver al curso</v-btn>
        </v-layout>
        <div v-if="!performed || prueba.typeTest_id === 2">
          <v-btn  class=" white--text mt-5"  id= "back-naranja"  @click="submitAnswer()" style="position:absolute;bottom:10%;right:17%;" large>Empezar prueba</v-btn>
        </div>
      </v-flex>
  </v-layout>


</template>

<script>
import { testService } from '@/services/Test.service'
import { answerService } from '@/services/Answer.service'
import { sectionUserService } from '@/services/SectionsUsers.service'
import { courceService } from '@/services/Cource.service'
import { testPerformedService } from '@/services/prueba/TestPerformed.service'
export default {
  data () {
    return {
      idPrueba: 0,
      prueba: {
        section: {
          section_title: ''
        }
      },
      answer: {},
      active2: null,
      idCurso: 0,
      curso: {},
      idQuestion: 0,
      cantidadPreguntas: 0,
      performed: false
    }
  },
  methods: {
    loadPrueba () {
      let vm = this
      testService.getById(vm.idPrueba).then(data => {
        vm.prueba = data.body
        vm.cantidadPreguntas = data.body.questions.length
      })
    },
    loadCurso () {
      let vm = this
      courceService.getById(1).then(data => {
        vm.curso = data.body
        vm.unidades = data.body.units
        vm.secciones = data.body.units.sections
        vm.competiciones = data.body.competences
        vm.objetivos = data.body.objectives
      })
    },
    submitAnswer () {
      let vm = this
      vm.answer.test_id = vm.idPrueba
      answerService.save(vm.answer).then(data => {
        vm.prueba = data.body
        this.$router.push({name: 'showTest', params: {id: data.body.id}})
      }, response => {
      })
    },
    submitSeccionUsuario () {
      let vm = this
      sectionUserService.save(vm.leccion.section.id).then(data => {
      }, response => {
      })
    },
    loadPerformed () {
      let vm = this
      testPerformedService.getById(vm.idPrueba).then(data => {
        vm.performed = data.body
      })
    },
    verCurso () {
      this.$router.push({name: 'showCourse', params: {id: this.curso.id}})
    }
  },
  mounted () {
    let vm = this
    vm.idPrueba = vm.$route.params.id
    vm.loadCurso()
    vm.loadPrueba()
    vm.loadPerformed()
  }
}
</script>

<style scoped>

.margin-0{
  margin: 0px;
}

.style-radio{
  margin-top: 15px;
  border-top: 1px solid black;
  border-right: 1px solid black;
  border-bottom: 1px solid black;
  border-left: 1px solid black;
   border-radius: 5px 5px 5px 5px;
   padding: 8px
}

.panelDerechaLeccion{
  background-color: white;
  min-height: 500px;
  margin-top: 10px
}

.estilo-p {
  color: white;
  margin-bottom: 0px
}
#back-naranja{
    background-color: #EB6330;
  }
  .gray--text{
  color: #747474;
}
.back-naranja{
    background-color: #EB6330;
  }
  .color-primary{
  color: #EB6330;
}
.color-gray{
  background-color: #747474;
}
.color-secondary-blue{
  background-color: rgb(47, 185, 235);
  
}

.color-grey-course{
  color: #757575;
}

.bordes{
  border-top: 1px solid #00897b;

  border-bottom: 1px solid #00897b;
  border-left: 1px solid #00897b;
}
.borde-derecha-abajo { 
  border-right: 1px solid #00897b;
  border-bottom: 1px solid #00897b;
 }


</style>




// WEBPACK FOOTER //
// src/components/Prueba/PreTest.vue